import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ClientLpTranslator } from '../clientLp.translator';
import { ClientLpAction } from '../clientLp.action';

type IDependencies = IClientApiDependencySegment;

export const loadClientLpEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ClientLpAction.load.started),
  mergeMap((params) => {
    return dependencies.api.getLp(params).pipe(
      mergeMap((response) => {
        const result = ClientLpTranslator.fromApiDetails(response);

        return [
          ClientLpAction.load.done({ params, result }),
          ClientLpAction.loadAdapterSchema.started({ adapterName: result.adapter }),
        ];
      }),
      catchApiError((error) => {
        return [
          ClientLpAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
